import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import InsuranceCardComponent from "@/modules/Insurance/components/InsuranceCardComponent.vue";
import FileCardComponent from "@/modules/FileUtils/components/FileCardComponent.vue";
import Insurance from "@/shared/model/Insurance";
import {reactive, ref, watch} from "vue";
import {useNavigationStore} from "@/modules/Navigation/store";
import {storeToRefs} from "pinia";
import SogSkeleton from "@/shared/ui/SogSkeleton.vue";
import apiInsurance from "@/modules/Insurance/api";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import ListFile from "@/shared/model/ListFile";
import apiFileUtils from "@/modules/FileUtils/api";
import apiHistory from "@/modules/History/api";
import History from "@/shared/model/History";
import getGuid from "@/shared/utils/getGuid";
import HistoryListComponent from "@/modules/History/components/HistoryListComponent.vue";
import {useAccountStore} from "@/stores/accountStore";
import {IdType} from "@/shared/model/idType";
import apiFile from "@/shared/services/apiFile";
import {useSpinner} from "@/shared/composables/SogSpinner";



export default /*@__PURE__*/_defineComponent({
  __name: 'InsuranceSideComponent',
  setup(__props) {


const _navigationStore = useNavigationStore();
const {currentInsuranceId} = storeToRefs(_navigationStore);
const {isRoot} = storeToRefs(useAccountStore())
const _insuranceId = ref("")
const _loadDetails = ref(true)
const _insurance = ref<Insurance>(new Insurance())
const _tempFile = ref<ListFile[]>([])
const _loadFiles = ref(true)
const _loadHistory = ref(true)
const _history: History[] = reactive<History[]>([])
const _key = ref("")
const _spinner = useSpinner("aside1")



watch(currentInsuranceId, async () => {
  if (!currentInsuranceId.value) {
    return
  }
  if (currentInsuranceId.value === _insuranceId.value) {
    return;
  }

  _insuranceId.value = currentInsuranceId.value
   await load()
})

async function load() {
  if (!currentInsuranceId.value) {
    return
  }
  _insuranceId.value = currentInsuranceId.value ?? '';

  _key.value = getGuid();

  const t_loadDetails = loadDetails(_key.value);
  const t_loadHistory = loadHistory(_key.value);
  const t_loadFiles = loadFiles(_key.value);

  await Promise.allSettled([t_loadDetails, t_loadHistory, t_loadFiles]);

}

async function loadDetails(key: string) {
  if (!_insuranceId.value) {
    return
  }
  _loadDetails.value = true;
  const res = await apiInsurance.load(_insuranceId.value);
  if (_key.value !== key) {
    return;
  }
  if (res) {
    _insurance.value = res.insurance;
    _loadDetails.value = false;
  }
}

async function loadFiles(key: string) {
  if (!_insuranceId.value) {
    return;
  }
  try {
    _loadFiles.value = true
    const listFile = await apiFileUtils.listFileStore(_insuranceId.value)
    if (_key.value !== key) {
      return
    }
    if (listFile) {
      _tempFile.value = listFile?.sort((a, b) => (a.date && b.date) ? Date.parse(b.date.toString()) - Date.parse(a.date.toString()) : 0) ?? [];
    }
  } finally {
    _loadFiles.value = false
  }
}

async function loadHistory(key: string) {
  if (!_insuranceId.value) {
    return;
  }
  try {
    _loadHistory.value = true
    _history.length = 0
    const listHistory = await apiHistory.listInsurance(_insuranceId.value)
    if (_key.value !== key) {
      return
    }
    if (listHistory)
      _history.push(...listHistory)
  } finally {
    _loadHistory.value = false
  }
}

function onVehicleRegistration() {
  _navigationStore.currentVehicleRegistrationId = _insurance.value.vehicleRegistrationId
}

function onDetails() {
  _navigationStore.showObject(IdType.Insurance, currentInsuranceId.value)
  /*
    _navigationStore.currentInsuranceId = currentInsuranceId.value
    _router.push("/insurance/details")
  */
}

async function onDownload(file: ListFile) {
  if (!file.personId)
    return;
  try {
    _spinner.show()
    const fileId = await apiFileUtils.initDownloadFile(file.id ?? "");
    if (fileId)
      await apiFile.downloadTempFile(fileId)

  } finally {
    _spinner.hide()
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogFlexColumn, {
    id: "aside1",
    style: {"align-items":"flex-start"}
  }, {
    default: _withCtx(() => [
      _createVNode(InsuranceCardComponent, {
        insurance: _insurance.value,
        "skeleton-visible": _loadDetails.value
      }, {
        default: _withCtx(() => [
          _createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              _createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-information",
                tooltip: "Details anzeigen",
                onClick: onDetails
              }),
              _withDirectives(_createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-car",
                tooltip: "Zulassungsdaten",
                onClick: onVehicleRegistration
              }, null, 512), [
                [_vShow, _unref(isRoot) && _insurance.value.vehicleRegistrationId]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["insurance", "skeleton-visible"]),
      _withDirectives(_createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Historie", -1)
            ]))]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(HistoryListComponent, { data: _history }, null, 8, ["data"])
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogSkeleton, null, null, 512), [
                [_vShow, _loadHistory.value]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, _loadHistory.value || _history.length>0]
      ]),
      _withDirectives(_createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Anhänge", -1)
            ]))]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_tempFile.value, (file) => {
            return (_openBlock(), _createBlock(SogCardContent, {
              key: file.id
            }, {
              default: _withCtx(() => [
                _createVNode(FileCardComponent, { file: file }, {
                  default: _withCtx(() => [
                    _createVNode(SogCardActionButton, {
                      "mdi-icon": "mdi-download",
                      tooltip: "Download",
                      onClick: ($event: any) => (onDownload(file))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["file"])
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogSkeleton, null, null, 512), [
                [_vShow, _loadFiles.value]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow,  _loadFiles.value || _tempFile.value.length!==0]
      ])
    ]),
    _: 1
  }))
}
}

})